import type { FaireProductEntity } from "../../entity_types/product";

export const p_7356uhhedx: FaireProductEntity = {
  token: "p_7356uhhedx",
  type: "product",
  name: "Matches in Tin - Tiger",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/0ff7fc82d9df182b86df0edd77012c93cd0dd74c62be0dbe448000808633821f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/69a5a15b6a848277935eb31c01a2b4bc63b080afe82e85e84b7b0731c3556f30.jpeg",
    "https://cdn.faire.com/fastly/be651589d60c07900907c71b62c9c44441dc6cec9d00a89ceb6487a72a3ae8fb.jpeg",
  ],
  priceDollars: 8.5,
  description:
    'These Tiger Safety Matches are housed in a reusable sliding tin featuring vintage tiger artwork inspired by antique natural history illustrations and decorative print ephemera. Richly coloured and full of character, the design brings a playful touch of nostalgia to coffee tables, mantelpieces, and fireside corners.\n\nContaining 100 safety matches with yellow tips, each tin features striker paper housed within a custom brass holder on the front of the tin, blending practicality with decorative charm. Designed to be refilled and reused, it makes a distinctive gift for interiors enthusiasts, hosts, or anyone who appreciates beautifully designed everyday objects.\n\nContains 100 safety matches. Keep away from children, heat, sparks, and open flames. Store in a dry place.\n\nSize: 12cm H x 8.5cm W x 2.5cm D | 4.72" H x 3.35" W x 0.89" D',
  tags: [],
  msrpDollars: 19,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:48.858Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
